import React, { Component, Fragment } from 'react';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
// import { readableResponseMessage } from 'ux-helpers';
import { Auth, API } from 'aws-amplify';
import PropTypes from 'proptypes';
import PaymentDetails from './../../screens/UserProfile/PaymentDetails';
import config from '../../../configuration/config';
import Cleave from 'cleave.js/react';
import './Forms.scss';
import DataLayer from '../../../configuration/dataLayer';
import AffirmService from '../../../services/AffirmService';
import FlexpayService from '../../../services/FlexpayService';
import Modal from 'react-modal';
import ApplicationTermsAndConditionsModal from './ApplicationTermsAndConditionsModal';

const publicIp = require('public-ip');

export default class MakePayment extends Component {
  // Removed getDerivedStateFromProps - accessing props directly instead of copying to state

  constructor(props) {
    super(props); // This is required in React class components

    if (this.props.payments.tripBalance > 0 || this.props.currentAddOns.length > 0) {
      // TODO: This is an issue, should use: totalAmountDue
      // Temp, until state is not overwritten onChange
      // Define the upReady function that will be called when Uplift is ready
      window.upReady = function() {
        if (window.Uplift && window.Uplift.Payments) {
          // Initialize Uplift payments
          FlexpayService.initUpliftPayments('#up-pay-monthly-container', this.props.userId);
          // Load the order info into Flexpay
          this.flexpayLoadOrderInfo();
        } else {
          console.error('Uplift.Payments still not available when upReady was called');
        }
      }.bind(this);

      // Initialize Flexpay with our callback
      // This should eventually trigger the callback which will show the payment option
      if (!window.Uplift || !window.Uplift.Payments) {
        FlexpayService.initializeFlexpay(this.upliftPaymentCallback);
      } else {
        window.upReady();
      }
    }

    // Helper method to set value and trigger change event
    this.setValueAndTriggerChange = (control, value) => {
      control.setValue(value);
      control.markAsDirty();
      control.updateValueAndValidity();
      control.markAsTouched();
      // Trigger change event
      if (typeof control.change === 'function') {
        control.change();
      }
    };

    this.clearMessage = () => {
      setTimeout(() => {
        this.setState({ formMessage: '' });
      }, 5000); // Clear message after 5 seconds
    };

    // Initialize refs for the buttons
    this.creditCardButtonRef = React.createRef();
    this.bankAccountButtonRef = React.createRef();
    this.checkButtonRef = React.createRef();

    // Initialize state with only truly internal component state
    this.state = {
      // Feature flags
      affirmEnabled: AffirmService.isAffirmEnabled(),
      flexpayEnabled: FlexpayService.isFlexpayEnabled(),
      achEnabled: config.ach.active,
      scheduledPaymentsEnabled: config.scheduledPayments.active,

      // UI state
      paymentSelection: {
        plan: '', // 'Full-Amount', 'One-Time', 'Flexpay', 'Affirm'
        type: '', // 'Credit Card', 'ACH', 'Check', 'Flexpay', 'Affirm'
        method: '', // 'Credit Card', 'ACH', 'Check'
      },
      flexpayConfirmStatus: 'hidden',
      formMessage: null,
      formMessageClass: '',
      paymentFee: '',
      paymentOptionTab: 'Make a Payment',
      showMonthlyPayments: true,
      showFlexpayOption: false, // Control visibility of Flexpay option
      showOfferNotAvailable: false, // Control visibility of not-available message
      flexpayServiceAvailable: true, // Track if Flexpay service is available

      // Payment state
      recurringPayment: false,
      recurringFrequency: null,
      recurringAmount: null,
      recurringPayments: null,
      paymentAmount: 0,

      // Loading states
      isSubmitting: false,

      // Other UI states
      showPayByCheck: false,
      ip: '0.0.0.0', // This might be needed for payment processing
    };

    this.currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    });
  }

  // Callback for Uplift payments
  upliftPaymentCallback = response => {
    const self = this; // Store reference to component

    const statusHandlers = {
      OFFER_AVAILABLE: function() {
        //Uplift Pay Monthly Offer available for this customer.
        self.setState({
          flexpayOfferAvailable: true,
          flexpayConfirmStatus: 'hidden',
          showFlexpayOption: true, // Add this to control visibility
        });
        // Fallback
        if (document.getElementById('flexpay-payment-option')) {
          document.getElementById('flexpay-payment-option').classList.remove('hidden');
        }
        if (document.getElementsByClassName('data-up-info-container').length > 0) {
          document.getElementsByClassName('data-up-info-container')[0].classList.remove('hidden');
        }
      },
      TOKEN_AVAILABLE: function() {
        //Uplift application has been completed and ready to pay in full.
        //Retrieve the token ONLY AFTER Purchase/Book button is clicked.
        self.setState({
          flexpayConfirmStatus: 'enabled',
        });
      },
      TOKEN_RETRIEVED: function() {
        //Uplift Payment Token successfully retrieved.
        var token = response.token;
        //utilize the retrieved token (virtual card) to pay in full by Uplift.
        self.processUpliftToken(token); // Use self instead of this
        self.setState({
          flexpayConfirmStatus: 'enabled',
        });
      },
      OFFER_UNAVAILABLE: function() {
        //Uplift Pay Monthly Offer is not available for this customer.
        self.setState({
          flexpayOfferAvailable: false,
          flexpayConfirmStatus: 'hidden',
          showFlexpayOption: true, // Show the option but mark as unavailable
          showOfferNotAvailable: true, // Control visibility of the not-available message
        });
        // Fallback
        if (document.getElementById('flexpay-payment-option')) {
          document.getElementById('flexpay-payment-option').classList.add('hidden');
        }
        if (document.getElementsByClassName('data-up-info-container').length > 0) {
          document.getElementsByClassName('data-up-info-container')[0].classList.add('hidden');
        }
      },
      SERVICE_UNAVAILABLE: function() {
        //Uplift Payments Service is unavailable.
        self.setState({
          showFlexpayOption: false, // Hide the option completely
          flexpayServiceAvailable: false, // Track service availability
        });
        // Fallback
        if (document.getElementsByClassName('data-up-info-container').length > 0) {
          document.getElementsByClassName('data-up-info-container')[0].classList.add('hidden');
        }
      },
    };

    // Execute the appropriate handler based on status
    if (statusHandlers[response.status]) {
      statusHandlers[response.status]();
    } else {
      console.error('Unknown Flexpay status:', response.status);
    }
  };

  flexpayLoadOrderInfo = () => {
    window.setTimeout(() => {
      const orderInfo = FlexpayService.createOrderInfo({
        trip: this.props.trip,
        user: this.props.user,
        totalAmountDue: this.returnTotalAmountDue(),
      });
      FlexpayService.loadOrderInfo(orderInfo);
    }, 500);
  };

  paymentAmountOnChange = (e, value) => {
    const paymentAmountControl = this.makePaymentForm.get('paymentAmount');
    // Use the value parameter if provided, otherwise fall back to form control value
    const paymentAmount =
      value !== undefined
        ? parseFloat(value)
        : parseFloat(this.makePaymentForm.controls.paymentAmount.value);

    const depositAmount =
      parseFloat(this.props.trip.payments.deposit) +
      (this.props.trip.payments.addOnsDeposit
        ? parseFloat(this.props.trip.payments.addOnsDeposit)
        : 0);

    if (paymentAmount === 0) {
      paymentAmountControl.setErrors({ notValidPrice: true });
    } else {
      paymentAmountControl.setErrors(null);
    }
    if (paymentAmount.length !== 0) {
      const fee = paymentAmount * (2.9 / 100);
      const feeSum = parseFloat(paymentAmount) + parseFloat(fee);
      if (paymentAmount > 0) {
        this.setState({
          paymentFee: `With the credit card transaction fee of 2.9%, your total amount is $${feeSum.toFixed(
            2
          )}. Send a check to avoid the fee, or for non-USA residents, contact us if you'd prefer a different payment method`,
        });
      }
    } else {
      this.setState({
        paymentFee: '',
      });
    }

    // Set Payment Amount && Reload Flexpay on change
    if (this.state.paymentAmount !== paymentAmount) {
      this.setState({
        paymentAmount,
      });
      // Reset Payment Form
      this.setValueAndTriggerChange(
        this.makePaymentForm.controls['paymentAmount'],
        paymentAmount.toFixed(2)
      );
      if (
        paymentAmount >= depositAmount &&
        this.state.flexpayEnabled &&
        window.Uplift &&
        window.Uplift.Payments
      ) {
        this.flexpayLoadOrderInfo();
      }
    }
  };

  componentDidMount() {
    this.setMinimumAmountDue();

    window.setTimeout(() => {
      publicIp
        .v4()
        .then(resp => {
          this.setState({
            ip: resp,
          });
        })
        .catch(error => {
          // IP Address Not Found
        });
    }, 1000);

    // Check if Affirm is enabled via environment variable
    if (this.state.affirmEnabled && this.props.payments.tripBalance > 0) {
      // Initialize Affirm using the service
      AffirmService.initializeAffirm();
    }

    // Check if Flexpay is enabled via environment variable
    if (this.state.flexpayEnabled && this.props.payments.tripBalance > 0) {
      // Initialize Flexpay using the service with the callback
      FlexpayService.initializeFlexpay(this.upliftPaymentCallback);

      // Set up the ready callback
      window.upReady = function() {
        // Initialize Uplift payments
        FlexpayService.initUpliftPayments('#up-pay-monthly-container', this.props.userId);
        // Load the order info into Flexpay
        this.flexpayLoadOrderInfo();
      }.bind(this);
    }

    // this.makePaymentForm.get('paymentAmount').onValueChanges.subscribe(() => {
    //   this.paymentAmountOnChange();
    // });
  }

  // Format date string from "Month Day, Year" to "YYYY-MM-DDTHH:MM" format
  formatDateString = dateStr => {
    return AffirmService.formatDateString(dateStr);
  };

  createAffirmItinerary = () => {
    return AffirmService.createAffirmItinerary(this.props.trip, this.props.user);
  };

  openAffirmLearnMore = () => {
    const paymentAmount = this.props.payments.tripBalance;
    AffirmService.openAffirmLearnMore(paymentAmount);
  };

  handleAffirmCheckout = () => {
    const { trip, user } = this.props;
    const totalAmountDue = this.returnTotalAmountDue();

    if (!totalAmountDue || totalAmountDue <= 0) {
      this.setState({
        message: 'No payment amount due',
      });
      return;
    }

    AffirmService.handleAffirmCheckout({
      trip,
      user,
      totalAmountDue,
      onFail: error => {
        console.error('Affirm checkout failed:', error);
        this.setState({
          message:
            'Payment with Affirm could not be completed. Please try again or choose another payment method.',
        });
      },
      onSuccess: result => {
        // Process successful Affirm checkout
        this.setState({
          message: 'Your Affirm payment plan has been approved! Processing your payment...',
        });
      },
    });
  };

  componentDidUpdate(prevProps) {
    // Check for props changes that require component updates
    if (prevProps.additionalTripCost !== this.props.additionalTripCost) {
      this.setMinimumAmountDue();
      if (this.props.payments.tripBalance > 0) {
        // Temp, until state is not overwritten onChange
        if (window.upReady) {
          // Load the order info into Flexpay
          this.flexpayLoadOrderInfo();
        }
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      message: '',
    });
  }

  returnMinAmountDue = () => {
    const depositSum = this.props.trip.payments.deposit + this.props.trip.payments.addOnsDeposit;
    const tripSum = this.props.trip.payments.tripAmount - this.props.trip.payments.tripBalance;
    const depositBalance = tripSum >= depositSum ? 0 : depositSum - tripSum;
    const minAmountDue = depositBalance > 0 ? depositBalance : this.returnTotalAmountDue();
    return minAmountDue.toFixed(2);
  };

  setMinimumAmountDue = () => {
    this.setValueAndTriggerChange(
      this.makePaymentForm.controls['paymentAmount'],
      this.returnMinAmountDue()
    );
  };

  showPaymentFee = paymentAmount => {
    if (
      this.state.paymentSelection &&
      this.state.paymentSelection.method === 'Credit Card' &&
      this.state.paymentSelection.type !== 'Flexpay' &&
      paymentAmount > 0
    ) {
      const fee = paymentAmount * (2.9 / 100);
      const feeSum = parseFloat(paymentAmount) + parseFloat(fee);
      this.setState({
        paymentFee: `With the credit card transaction fee of 2.9%, your total amount is $${feeSum.toFixed(
          2
        )}. Send a check to avoid the fee, or for non-USA residents, contact us if you'd prefer a different payment method`,
      });
    } else {
      this.setState({
        paymentFee: '',
      });
    }
  };

  togglePaymentDetails = (e, tripIndex) => {
    e.preventDefault();

    if (tripIndex === this.state.paymentDetails) {
      this.setState({
        paymentDetails: null,
      });
    } else {
      this.setState({
        paymentDetails: tripIndex,
      });
    }
  };

  returnTotalAmountDue = () => {
    const tripAmount = this.props.trip.payments.tripAmount;
    const tripBalance = this.props.trip.payments.tripBalance;
    let totalAmountDue = tripBalance;
    const promotionalDiscount = this.props.trip.tripdiscountlivenow
      ? this.props.trip.tripdiscountlivenow
      : 0;
    const amountPaid = tripAmount - tripBalance;

    if (this.props.trip.payments.deposit > amountPaid && promotionalDiscount > 0) {
      totalAmountDue = totalAmountDue - promotionalDiscount;
    }

    for (let i = 0; i < this.props.trip.currentAddOns.length; i += 1) {
      const currentAddOn = this.props.trip.currentAddOns[i];
      if (!currentAddOn.type || currentAddOn.type !== 'Product') {
        totalAmountDue += currentAddOn.unitPrice;
      }
    }
    return totalAmountDue;
  };

  openTermsAndConditionsModal = () => {
    this.setState({
      activeModal: 'termsAndConditions',
    });
  };

  makePaymentForm = FormBuilder.group({
    tripId: this.props.tripId,
    tripName: this.props.tripName,
    paymentAmount: ['', Validators.required],
    ccOwnerName: [''],
    ccNumber: [''],
    ccExpiration: [''],
    ccCVV: [''],
    accountHolderName: [''],
    routingNumber: [''],
    accountNumber: [''],
    accountType: [''],
  });

  resetPaymentForm = () => {
    this.makePaymentForm.reset();
    const paymentAmount =
      this.state.paymentSelection &&
      (this.state.paymentSelection.plan === 'Full-Amount' ||
        this.state.paymentSelection.type === 'Flexpay')
        ? this.returnTotalAmountDue()
        : this.returnMinAmountDue();
    this.setValueAndTriggerChange(this.makePaymentForm.controls['paymentAmount'], paymentAmount);
    this.showPaymentFee(paymentAmount);
  };

  setFormMessage = (message, messageClass) => {
    this.setState({ formMessage: message, formMessageClass: messageClass });
    setTimeout(() => {
      this.setState({ formMessage: '', formMessageClass: '' });
    }, 6000);
  };

  applyPaymentAndUpdateState = (paymentAmount, paymentFee, paymentId) => {
    // TODO: There's still a bug here where the values are not updated correctly.
    // TODO, TODO: This is a hack.  We should call the API for a balance.

    if (paymentAmount >= 1) {
      const { tripAmount, tripBalance } = this.props.payments;
      const newTripBalance = tripBalance - paymentAmount;

      let _trip = this.props.trip;
      _trip.payments.tripBalance = newTripBalance;

      let today = new Date(),
        _date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

      const paymentObject = {
        opportunity: this.props.tripId,
        name: this.props.tripName + ' | Credit Card Payment',
        amount: paymentAmount + paymentFee,
        transactionFee: paymentFee,
        paymentType: this.state.paymentSelection.type,
        paymentMethod: this.state.paymentSelection.method,
        date: _date,
        transactionId: paymentId,
        status: 'Completed',
      };

      _trip.payments.completedPayments.push(paymentObject);

      this.setState({
        trip: _trip,
        tripBalance: newTripBalance,
        percentageComplete: Math.round(((tripAmount - newTripBalance) / tripAmount) * 100),
      });

      if (this.state.flexpayEnabled && window.Uplift && window.Uplift.Payments) {
        this.flexpayLoadOrderInfo();
      }
    }

    if (this.props.payments.tripBalance <= 0) {
      this.setState({ message: '' });
    }

    this.resetPaymentForm();
  };

  togglePayByCheck = _bool => {
    this.setState({
      showPayByCheck: !_bool,
      message: '',
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  setPaymentSelection = (plan, type, method) => {
    const newSelection = { plan, type, method };
    this.setState(
      {
        paymentSelection: newSelection,
      },
      () => {
        if (method !== '') {
          this.resetPaymentForm();
        }
      }
    );
  };

  flexpayConfirm = () => {
    if (window.Uplift && window.Uplift.Payments) {
      this.setState({ isSubmitting: true });
      window.Uplift.Payments.getToken();
    }
  };

  resetButtonStates = () => {
    this.setState({ isSubmitting: false });
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    // Set submitting state
    this.setState({ isSubmitting: true });

    const { type, method } = this.state.paymentSelection;

    if (method === 'Credit Card') {
      if (this.makePaymentForm.controls.ccOwnerName.value === '') {
        this.makePaymentForm.controls['ccOwnerName'].setErrors({
          required: true,
        });
      }
      const ccValue = this.makePaymentForm.controls['ccNumber'].value || '';
      const cc = ccValue.replace(/\s+/g, '');
      if (cc === '') {
        this.makePaymentForm.controls['ccNumber'].setErrors({ required: true });
      }
      if (!/^[0-9]{15,16}$/.test(cc)) {
        this.makePaymentForm.controls['ccNumber'].setErrors({ invalid: true });
      }
      const exp = this.makePaymentForm.controls['ccExpiration'].value || '';
      if (exp === '') {
        this.makePaymentForm.controls['ccExpiration'].setErrors({
          required: true,
        });
      }
      const cvv = this.makePaymentForm.controls['ccCVV'].value || '';
      if (cvv === '') {
        this.makePaymentForm.controls['ccCVV'].setErrors({ required: true });
      }
      if (!/^[0-9]{3,4}$/.test(cvv)) {
        this.makePaymentForm.controls['ccCVV'].setErrors({ invalid: true });
      }
      const postalCode = this.makePaymentForm.controls['ccPostalCode'].value || '';
      if (postalCode === '') {
        this.makePaymentForm.controls['ccPostalCode'].setErrors({ required: true });
      }
      // if (!/^[0-9]{5}$/.test(postalCode)) {
      //   this.makePaymentForm.controls['ccPostalCode'].setErrors({ invalid: true });
      // }
    } else if (method === 'ACH') {
      if (this.makePaymentForm.controls.accountHolderName.value === '') {
        this.makePaymentForm.controls['accountHolderName'].setErrors({
          required: true,
        });
      }
      const routingNumber = this.makePaymentForm.controls['routingNumber'].value;
      if (routingNumber === '') {
        this.makePaymentForm.controls['routingNumber'].setErrors({
          required: true,
        });
      }
      if (!/^[0-9]{9}$/.test(routingNumber)) {
        this.makePaymentForm.controls['routingNumber'].setErrors({
          invalid: true,
        });
      }
      const accountNumber = this.makePaymentForm.controls['accountNumber'].value;
      if (accountNumber === '') {
        this.makePaymentForm.controls['accountNumber'].setErrors({
          required: true,
        });
      }
      if (!/^[0-9]{4,17}$/.test(accountNumber)) {
        this.makePaymentForm.controls['accountNumber'].setErrors({
          invalid: true,
        });
      }
    } else {
      this.makePaymentForm.controls['ccOwnerName'].setErrors(null);
      this.makePaymentForm.controls['ccNumber'].setErrors(null);
      this.makePaymentForm.controls['ccExpiration'].setErrors(null);
      this.makePaymentForm.controls['ccCVV'].setErrors(null);
      this.makePaymentForm.controls['accountHolderName'].setErrors(null);
      this.makePaymentForm.controls['routingNumber'].setErrors(null);
      this.makePaymentForm.controls['accountNumber'].setErrors(null);
    }

    if (this.makePaymentForm.status === 'VALID') {
      const paymentAmount = this.makePaymentForm.controls.paymentAmount.value;
      const paymentFee = paymentAmount * (2.9 / 100);
      const totalPaymentAmount = parseFloat(paymentAmount) + parseFloat(paymentFee);

      // this.makePaymentForm.handleSubmit();

      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: this.makePaymentForm.value,
        };
        options.body.ip = this.state.ip;
        options.body.paymentType = type;
        options.body.paymentMethod = method;
        options.body.paymentFees = method === 'Credit Card' ? paymentFee : 0;
        options.body.paymentAmount = paymentAmount.toString();
        options.body.totalPaymentAmount = totalPaymentAmount.toString();
        options.body.tripId = this.props.tripId;
        options.body.tripName = this.props.tripName;

        // Add recurring payment information if applicable
        if (this.state.recurringPayment) {
          options.body.recurringPayment = true;
          options.body.recurringFrequency = this.state.recurringFrequency;
          options.body.recurringAmount = this.state.recurringAmount.toString();
          options.body.recurringPayments = this.state.recurringPayments;
        }

        API.post('give-api', '/user/payments', options)
          .then(response => {
            if (response && response.Data && response.Data.paymentId) {
              if (window.Uplift && window.Uplift.Payments) {
                if (type === 'Flexpay') {
                  window.Uplift.Payments.confirm({
                    is_pay_monthly: true,
                    confirmation_id: response.Data.paymentId,
                  });
                  if (document.getElementsByClassName('data-up-info-container').length > 0) {
                    document
                      .getElementsByClassName('data-up-info-container')[0]
                      .classList.add('hidden');
                  }
                } else {
                  window.Uplift.Payments.confirm({
                    is_pay_monthly: false,
                    confirmation_id: response.Data.paymentId,
                  });
                }
              }
            }
            if (method === 'Credit Card') {
              if (
                this.props.payments.deposit -
                  (this.props.payments.tripAmount - this.props.payments.tripBalance) >
                  0 &&
                options.body.paymentAmount >=
                  this.props.payments.deposit -
                    (this.props.payments.tripAmount - this.props.payments.tripBalance)
              ) {
                DataLayer.createEcommercePurchaseEvent(
                  'add_payment_info',
                  options.body.paymentAmount,
                  response.Data.paymentId,
                  this.props.tripName,
                  options.body.paymentFees,
                  'Credit Card'
                );
              } else {
                this.setFormMessage(
                  response.Message ? response.Message : 'We successfully processed your payment.',
                  'success'
                );
                DataLayer.createEcommercePurchaseEvent(
                  'purchase',
                  options.body.paymentAmount,
                  response.Data.paymentId,
                  this.props.tripName,
                  options.body.paymentFees,
                  'Credit Card'
                );
              }
              this.applyPaymentAndUpdateState(
                parseFloat(options.body.paymentAmount),
                parseFloat(options.body.paymentFees),
                response.Data.paymentId
              );
              this.props.handleRouting();
            } else if (method === 'ACH') {
              this.setFormMessage(
                response.Message
                  ? response.Message
                  : 'We initiated your bank transfer. Please allow 2-3 business days for the funds to be processed.',
                'success'
              );
              DataLayer.createEcommercePurchaseEvent(
                'add_payment_info',
                options.body.paymentAmount,
                response.Data.paymentId,
                this.props.tripName,
                options.body.paymentFees,
                'ACH'
              );
            } else {
              this.setFormMessage(
                response.Message ? response.Message : 'We successfully processed your payment.',
                'success'
              );
              DataLayer.createEcommercePurchaseEvent(
                'add_payment_info',
                options.body.paymentAmount,
                response.Data.paymentId,
                this.props.tripName,
                options.body.paymentFees,
                'Check'
              );
            }
            this.setPaymentSelection('', '', '');
          })
          .catch(error => {
            console.error('Payment error:', error);

            // Simple error handling - extract message from JSON response
            let errorMessage = 'An error occurred while processing your payment. Please try again.';

            try {
              // Try to parse the error response
              errorMessage = error.response.data.Message;
            } catch (e) {
              console.error('Error parsing error response:', e);
            }

            this.setFormMessage(errorMessage, 'error');

            if (type === 'Flexpay' && window.Uplift && window.Uplift.Payments) {
              window.Uplift.Payments.error(errorMessage);
            }
          })
          .finally(() => {
            this.resetButtonStates();
            this.resetPaymentForm();
          });
      });

      this.makePaymentForm.submitted = false;
    } else {
      this.resetButtonStates();
    }
  };

  processUpliftToken = token => {
    if (!token) {
      console.error('Invalid Uplift token received');
      this.setState({
        formMessage:
          'We had a problem processing your payment with Flex Pay. Please try again or choose another payment method.',
        isSubmitting: false,
      });
      this.clearMessage();
      return;
    }

    try {
      // Populate the credit card form with Uplift token data
      // const form = this.makePaymentForm.controls;

      // Set card owner name
      this.setValueAndTriggerChange(
        this.makePaymentForm.controls['ccOwnerName'],
        token.name_on_card
      );

      // Set card number
      this.setValueAndTriggerChange(this.makePaymentForm.controls['ccNumber'], token.card_number);

      // Set card expiration (format: MM/YY)
      const month = String(token.expiration_month).padStart(2, '0');
      const year = String(token.expiration_year).slice(-2); // Get last 2 digits
      this.setValueAndTriggerChange(
        this.makePaymentForm.controls['ccExpiration'],
        `${month}/${year}`
      );

      // Set CVV
      this.setValueAndTriggerChange(this.makePaymentForm.controls['ccCVV'], token.card_ccv);

      // Set postal code
      this.setValueAndTriggerChange(
        this.makePaymentForm.controls['ccPostalCode'],
        token.contact.postal_code
      );

      this.handleSubmit();
    } catch (error) {
      // Do something else here: reset.
      console.error('Error processing Flexpay token:', error);
      this.setState({
        formMessage:
          'Error processing your payment. Please try again or choose another payment method.',
      });
      this.resetButtonStates();
      this.clearMessage();
    }
  };

  render() {
    const { deposit, addOnsDeposit, tripBalance, tripAmount } = this.props.payments;
    const depositSum = deposit + addOnsDeposit;
    const tripSum = tripAmount - tripBalance;

    // Total Amount Due:
    const totalAmountDue = this.returnTotalAmountDue();
    const penniesDue = Math.round(totalAmountDue * 100);

    const percentageComplete = Math.round(((tripAmount - tripBalance) / tripAmount) * 100);

    const depositBalance = tripSum >= depositSum ? 0 : depositSum - tripSum;
    let amountAppliedToAddOnDeposit = 0;

    if (
      depositBalance > 0 &&
      tripSum >= this.props.trip.payments.deposit &&
      this.props.trip.currentAddOns.length > 0
    ) {
      amountAppliedToAddOnDeposit = depositBalance;
    }

    // Payment Options
    const { plan, type, method } = this.state.paymentSelection;
    const { flexpayEnabled, achEnabled, isSubmitting } = this.state;

    return (
      <Fragment>
        <h3 className="h1-style muted margin-bottom-text">
          {`Payments ${totalAmountDue < 1 ? 'Completed' : ''}`}
        </h3>

        <div className="status-bar">
          <div className="percentage-complete" style={{ width: `${percentageComplete}%` }}>
            {percentageComplete > 0 ? `${percentageComplete}% There!` : 'Make a Payment!'}
          </div>
        </div>

        {totalAmountDue > 0 ? (
          <h4 className="make-payment-title darker">
            Only{' '}
            {tripAmount - tripBalance < deposit
              ? `${this.currencyFormatter.format(
                  deposit + addOnsDeposit - (tripAmount - tripBalance)
                )} left to secure your trip!`
              : ''}
            {tripAmount - tripBalance >= deposit &&
            tripAmount - tripBalance < deposit + addOnsDeposit &&
            addOnsDeposit > 0
              ? `${this.currencyFormatter.format(
                  depositSum - tripSum
                )} left to secure your add-ons!`
              : ''}
            {tripAmount - tripBalance >= deposit + addOnsDeposit
              ? `${this.currencyFormatter.format(totalAmountDue)} left!`
              : ''}
            <button
              className="icon-container list-icon"
              onClick={e => this.togglePaymentDetails(e, this.state.tripIndex)}
            />
          </h4>
        ) : (
          <h4 className="make-payment-title darker">
            <button
              className="icon-container list-icon"
              onClick={e => this.togglePaymentDetails(e, this.state.tripIndex)}
            />
          </h4>
        )}

        <PaymentDetails trip={this.props.trip} additionalTripCost={this.props.additionalTripCost} />

        {totalAmountDue > 0 ? (
          <div>
            {/* Payment Option Tabs */}
            <div
              className="payment-method-tabs"
              style={{
                marginBottom: '0',
                display: 'flex',
                width: '100%',
              }}
            >
              <div className="payment-options-heading">Payment Options</div>
            </div>

            {/* Content container for the payment options */}
            <div className="payment-container">
              <div className="payment-options-container">
                {/* Pay Full Amount Option */}
                {(plan === '' || plan === 'Full-Amount') && (
                  <div
                    className={`payment-option-button ${plan === 'Full-Amount' ? 'selected' : ''}`}
                    style={{ position: 'relative' }}
                    onClick={() => {
                      if (isSubmitting) {
                        return;
                      }
                      if (
                        flexpayEnabled &&
                        type === 'Flexpay' &&
                        window.Uplift &&
                        window.Uplift.Payments
                      ) {
                        window.Uplift.Payments.deselect();
                      }
                      if (plan === 'Full-Amount') {
                        this.setPaymentSelection('', '', '');
                      } else {
                        this.setValueAndTriggerChange(
                          this.makePaymentForm.controls['paymentAmount'],
                          totalAmountDue.toFixed(2)
                        );
                        this.setPaymentSelection('Full-Amount', '', '');
                      }
                    }}
                  >
                    <div className="option-content">
                      <div className="radio-indicator"></div>
                      <div className="option-text">
                        <div className="amount">Pay in Full Today</div>
                        <div className="description">
                          Make a one-time payment of {this.currencyFormatter.format(totalAmountDue)}{' '}
                          and you're all set!
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Pay One-Time Option */}
                {(plan === '' || plan === 'One-Time') && (
                  <div
                    className={`payment-option-button ${plan === 'One-Time' ? 'selected' : ''}`}
                    onClick={() => {
                      if (isSubmitting) {
                        return;
                      }
                      if (
                        flexpayEnabled &&
                        type === 'Flexpay' &&
                        window.Uplift &&
                        window.Uplift.Payments
                      ) {
                        window.Uplift.Payments.deselect();
                      }
                      if (plan === 'One-Time') {
                        this.setPaymentSelection('', '', '');
                      } else {
                        this.setValueAndTriggerChange(
                          this.makePaymentForm.controls['paymentAmount'],
                          depositBalance > 0
                            ? depositBalance.toFixed(2)
                            : (totalAmountDue / 2).toFixed(2)
                        );
                        this.setPaymentSelection('One-Time', '', '');
                      }
                    }}
                  >
                    <div className="option-content">
                      <div className="radio-indicator"></div>
                      <div className="option-text">
                        <div className="amount">Make a One-Time Payment</div>
                        <div className="description">
                          {depositBalance > 0
                            ? `Pay your ${this.currencyFormatter.format(
                                depositBalance
                              )} deposit today to secure your spot! Then, pay your remaining balance on your own timeline`
                            : `Pay towards your remaining balance of ${this.currencyFormatter.format(
                                totalAmountDue
                              )}`}{' '}
                          by {this.props.trip.payments.paymentDue}.
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Manual Payment Methods */}
                {plan !== '' && type !== 'Flexpay' && type !== 'Affirm' && (
                  <Fragment>
                    <div
                      className={`payment-option-button payment-option-type${
                        type === 'Credit Card' ? ' selected' : ''
                      }`}
                      onClick={() => {
                        if (isSubmitting) {
                          return;
                        }
                        if (
                          flexpayEnabled &&
                          type === 'Flexpay' &&
                          window.Uplift &&
                          window.Uplift.Payments
                        ) {
                          window.Uplift.Payments.deselect('Credit Card');
                        }
                        if (type === 'Credit Card' && method === 'Credit Card') {
                          this.setPaymentSelection(plan, '', '');
                        } else {
                          this.setPaymentSelection(plan, 'Credit Card', 'Credit Card');
                        }
                      }}
                    >
                      <div className="option-content">
                        <div className="radio-indicator"></div>
                        <div className="option-text">
                          <div className="amount">Pay with a credit card</div>
                          <div className="description">
                            Make a one-time payment{' '}
                            {plan !== 'One-Time' &&
                              `of ${this.currencyFormatter.format(totalAmountDue)}`}{' '}
                            {plan === 'One-Time' &&
                              depositBalance > 0 &&
                              `towards your ${this.currencyFormatter.format(
                                depositBalance
                              )} deposit`}{' '}
                            today!
                          </div>
                        </div>
                      </div>
                    </div>
                    {achEnabled && (
                      <div
                        className={`payment-option-button payment-option-type${
                          type === 'ACH' ? ' selected' : ''
                        }`}
                        onClick={() => {
                          if (isSubmitting) {
                            return;
                          }
                          if (
                            flexpayEnabled &&
                            type === 'Flexpay' &&
                            window.Uplift &&
                            window.Uplift.Payments
                          ) {
                            window.Uplift.Payments.deselect('ACH');
                          }
                          if (type === 'ACH') {
                            this.setPaymentSelection(plan, '', '');
                          } else {
                            this.setPaymentSelection(plan, 'ACH', 'ACH');
                          }
                        }}
                      >
                        <div className="option-content">
                          <div className="radio-indicator"></div>
                          <div className="option-text">
                            <div className="amount">Pay with a bank account</div>
                            <div className="description">
                              Make a one-time payment{' '}
                              {plan !== 'One-Time' &&
                                `of ${this.currencyFormatter.format(totalAmountDue)}`}{' '}
                              {plan === 'One-Time' &&
                                depositBalance > 0 &&
                                `towards your ${this.currencyFormatter.format(
                                  depositBalance
                                )} deposit`}{' '}
                              today!
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className={`payment-option-button payment-option-type${
                        type === 'Check' ? ' selected' : ''
                      }`}
                      onClick={() => {
                        if (isSubmitting) {
                          return;
                        }
                        if (
                          flexpayEnabled &&
                          type === 'Flexpay' &&
                          window.Uplift &&
                          window.Uplift.Payments
                        ) {
                          window.Uplift.Payments.deselect('Check');
                        }
                        if (type === 'Check') {
                          this.setPaymentSelection(plan, '', '');
                        } else {
                          this.setPaymentSelection(plan, 'Check', 'Check');
                        }
                      }}
                    >
                      <div className="option-content">
                        <div className="radio-indicator"></div>
                        <div className="option-text">
                          <div className="amount">Pay by check</div>
                          <div className="description">
                            Make a one-time payment{' '}
                            {plan !== 'One-Time' &&
                              `of ${this.currencyFormatter.format(totalAmountDue)}`}{' '}
                            {plan === 'One-Time' &&
                              depositBalance > 0 &&
                              `towards your ${this.currencyFormatter.format(
                                depositBalance
                              )} deposit`}{' '}
                            today!
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
                {/* Pay Over Time with Flexpay Option */}
                <div
                  id="flexpay-payment-option"
                  className={`payment-option-button ${
                    this.state.showFlexpayOption === false ? 'hidden' : ''
                  } ${type === 'Flexpay' ? 'selected' : ''} ${
                    this.state.flexpayOfferAvailable === false ? 'disabled' : ''
                  }`}
                  onClick={() => {
                    if (isSubmitting) {
                      return;
                    }
                    if (this.state.flexpayOfferAvailable === false) {
                      return;
                    }
                    if (type === 'Flexpay') {
                      this.setPaymentSelection(plan, '', '');
                      window.Uplift.Payments.deselect();
                    } else {
                      this.setPaymentSelection(plan, 'Flexpay', 'Credit Card');
                      setTimeout(() => {
                        // Then handle Uplift payment after state is updated and UI has refreshed
                        if (window.Uplift && window.Uplift.Payments) {
                          // Make sure the container is visible
                          const container = document.getElementById('up-pay-monthly-container');
                          if (container) {
                            container.style.display = 'block';
                          }
                          // Select Uplift payment
                          window.Uplift.Payments.select();
                        } else {
                          console.error('Flexpay is not properly initialized');
                        }
                      }, 0);
                    }
                  }}
                >
                  <div className="option-content">
                    <div className="radio-indicator"></div>
                    <div className="option-text">
                      <div id="up-pay-monthly-selector">
                        <div className="amount">Book Now, Pay Later</div>
                        <span
                          className="description"
                          id="up-pay-monthly-selector-from-pricing"
                          style={{ display: 'none', cursor: 'pointer' }}
                          data-up-price-value={penniesDue}
                          data-up-price-type="total"
                        >
                          {depositBalance > 0
                            ? `Secure your spot now & pay later - even after your trip,`
                            : `Pay off your balance - even after your trip,`}{' '}
                          with Flex Pay{' '}
                          <b className="primary data-up-from-price">
                            starting at $
                            <span className="primary" data-up-from-currency-unit-major=""></span>
                            /mo
                            <span data-up-tooltip="">
                              <svg
                                stroke="currentColor"
                                fill="#0f9300"
                                strokeWidth="0"
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path>
                              </svg>
                            </span>
                          </b>
                          <span
                            className="description"
                            style={{ display: 'none' }}
                            data-up-promo="zero-percent"
                          >
                            $0 down and interest-free payments also available.{' '}
                          </span>
                        </span>
                        <span className="description">
                          <a href="https://go.givevolunteers.org/flexpayhelp" target="_blank">
                            Read our helpful tips before you apply
                          </a>
                        </span>
                        <span
                          id="up-offer-not-available"
                          className="description"
                          data-up-error=""
                          style={{ display: 'none' }}
                        >
                          Not available for this trip.{' '}
                          <span data-up-tooltip="">
                            <svg
                              stroke="currentColor"
                              fill="#0f9300"
                              strokeWidth="0"
                              viewBox="0 0 1024 1024"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path>
                            </svg>{' '}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Form */}
              {totalAmountDue > 0 && (
                <div
                  className="make-payment-container"
                  style={
                    type === 'Flexpay' || type === 'Affirm' || type === ''
                      ? { display: 'none' }
                      : { display: 'block' }
                  }
                >
                  <FieldGroup
                    control={this.makePaymentForm}
                    key={`payment-form-${isSubmitting}`}
                    render={({ value, submitted, type }) => (
                      <form
                        name="Make Payment"
                        id="make-payment-form"
                        className={`make-payment-form ${type === 'Flexpay' ? 'flexpay-form' : ''}`}
                        onSubmit={e => this.handleSubmit(e)}
                        autoComplete="off"
                      >
                        <div>
                          <FieldControl
                            name="paymentAmount"
                            className="paymentForm"
                            render={({ handler, touched, hasError, pristine }) => (
                              <div className="inputContainer inputContainer-no-margin">
                                <span className="square-icon make-payment-dollar-sign">$</span>
                                <input
                                  id="paymentAmount"
                                  className="make-payment-input"
                                  type="number"
                                  {...handler()}
                                  onInput={e => this.paymentAmountOnChange(e, e.target.value)}
                                />
                                <label
                                  htmlFor="paymentAmount"
                                  className={`label make-payment-label ${
                                    pristine && this.value === '' ? '' : 'notEmpty'
                                  }`}
                                >
                                  Amount you&apos;d like to pay today
                                  <span className="error">
                                    {(touched || submitted) &&
                                      hasError('required') &&
                                      ' - Required'}
                                    {hasError('notValidPrice') &&
                                      '- value cannot be less than zero'}
                                  </span>
                                </label>
                              </div>
                            )}
                          />
                        </div>
                        <div className="payment-form-label">
                          <p className="small">Payment Information</p>
                        </div>
                        {method === 'Credit Card' && (
                          <div className="payment-form">
                            <div className="form-fields">
                              <div className="row">
                                <div className="col-md-12">
                                  <FieldControl
                                    name="ccOwnerName"
                                    render={({ handler, touched, hasError, pristine }) => (
                                      <div className="inputContainer">
                                        <input
                                          placeholder=""
                                          id="ccOwnerName"
                                          className={
                                            (touched || submitted) && hasError('required')
                                              ? 'form-control error'
                                              : 'form-control' + (handler().value ? ' notNull' : '')
                                          }
                                          {...handler()}
                                        />
                                        <label
                                          htmlFor="ccOwnerName"
                                          className={`label small ${
                                            !pristine || handler().value ? 'notEmpty' : ''
                                          }`}
                                        >
                                          Card Holder's Name
                                          {hasError('required') && (
                                            <span className="error"> - Required</span>
                                          )}
                                        </label>
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-7 col-sm-12">
                                  <FieldControl
                                    name="ccNumber"
                                    render={({ handler, touched, hasError, pristine }) => (
                                      <div className="inputContainer">
                                        <Cleave
                                          placeholder=""
                                          id="ccNumber"
                                          className={
                                            (touched || submitted) &&
                                            (hasError('required') || hasError('invalid'))
                                              ? 'form-control error'
                                              : 'form-control' + (handler().value ? ' notNull' : '')
                                          }
                                          options={{
                                            creditCard: true,
                                          }}
                                          {...handler()}
                                        />
                                        <label
                                          htmlFor="ccNumber"
                                          className={`label small ${
                                            !pristine || handler().value ? 'notEmpty' : ''
                                          }`}
                                        >
                                          Credit Card Number
                                          {hasError('required') && (
                                            <span className="error"> - Required</span>
                                          )}
                                          {hasError('invalid') && (
                                            <span className="error"> - Invalid</span>
                                          )}
                                        </label>
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="col-md-3 col-sm-12">
                                  <FieldControl
                                    name="ccExpiration"
                                    render={({ handler, touched, hasError, pristine }) => (
                                      <div className="inputContainer">
                                        <Cleave
                                          placeholder=""
                                          id="ccExpiration"
                                          className={
                                            (touched || submitted) &&
                                            (hasError('required') || hasError('invalid'))
                                              ? 'form-control error'
                                              : 'form-control' + (handler().value ? ' notNull' : '')
                                          }
                                          options={{
                                            date: true,
                                            datePattern: ['m', 'y'],
                                          }}
                                          {...handler()}
                                        />
                                        <label
                                          htmlFor="ccExpiration"
                                          className={`label small ${
                                            !pristine || handler().value ? 'notEmpty' : ''
                                          }`}
                                        >
                                          MM/YY
                                          {hasError('required') && (
                                            <span className="error"> - Required</span>
                                          )}
                                          {hasError('invalid') && (
                                            <span className="error"> - Invalid</span>
                                          )}
                                        </label>
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="col-md-2 col-sm-12">
                                  <FieldControl
                                    name="ccCVV"
                                    render={({ handler, touched, hasError, pristine }) => (
                                      <div className="inputContainer">
                                        <input
                                          id="ccCVV"
                                          name="ccCVV"
                                          type="number"
                                          placeholder=""
                                          maxLength="3"
                                          className={
                                            (touched || submitted) &&
                                            (hasError('required') || hasError('invalid'))
                                              ? 'form-control error'
                                              : 'form-control' + (handler().value ? ' notNull' : '')
                                          }
                                          {...handler()}
                                        />
                                        <label
                                          htmlFor="ccCVV"
                                          className={`label small ${
                                            !pristine || handler().value ? 'notEmpty' : ''
                                          }`}
                                        >
                                          CVV
                                          {hasError('required') && (
                                            <span className="error"> - Required</span>
                                          )}
                                          {hasError('invalid') && (
                                            <span className="error"> - Invalid</span>
                                          )}
                                        </label>
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12 col-sm-12">
                                  <FieldControl
                                    name="ccPostalCode"
                                    render={({ handler, touched, hasError, pristine }) => (
                                      <div className="inputContainer">
                                        <input
                                          id="ccPostalCode"
                                          name="ccPostalCode"
                                          placeholder=""
                                          className={
                                            (touched || submitted) &&
                                            (hasError('required') || hasError('invalid'))
                                              ? 'form-control error'
                                              : 'form-control' + (handler().value ? ' notNull' : '')
                                          }
                                          {...handler()}
                                        />
                                        <label
                                          htmlFor="ccPostalCode"
                                          className={`label small ${
                                            !pristine || handler().value ? 'notEmpty' : ''
                                          }`}
                                        >
                                          Credit Card Postal Code
                                          {hasError('required') && (
                                            <span className="error"> - Required</span>
                                          )}
                                          {hasError('invalid') && (
                                            <span className="error"> - Invalid</span>
                                          )}
                                        </label>
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                              <div>
                                <button
                                  onClick={e => this.handleSubmit(e)}
                                  className={`small ${isSubmitting ? 'btn-text-hide' : ''}`}
                                  type="submit"
                                  id="pay-by-cc"
                                  data-tip="React-tooltip"
                                  disabled={isSubmitting}
                                  ref={this.creditCardButtonRef}
                                >
                                  Pay By Credit or Debit Card
                                  <span
                                    className={`${isSubmitting ? 'loader loader-pay-by-cc' : ''}`}
                                  />
                                </button>
                              </div>
                              <p className="small">{this.state.paymentFee}</p>
                            </div>
                          </div>
                        )}
                        {method === 'ACH' && (
                          <div className="payment-form">
                            <div className="row">
                              <div className="col-md-12">
                                <FieldControl
                                  name="accountHolderName"
                                  render={({ handler, touched, hasError, pristine }) => (
                                    <div className="inputContainer">
                                      <input
                                        placeholder=""
                                        id="accountHolderName"
                                        className={
                                          (touched || submitted) && hasError('required')
                                            ? 'form-control error'
                                            : 'form-control' + (handler().value ? ' notNull' : '')
                                        }
                                        {...handler()}
                                      />
                                      <label
                                        htmlFor="accountHolderName"
                                        className={`label small ${
                                          !pristine || handler().value ? 'notEmpty' : ''
                                        }`}
                                      >
                                        Account Holder's Name
                                        {hasError('required') && (
                                          <span className="error"> - Required</span>
                                        )}
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 col-sm-12">
                                <FieldControl
                                  name="routingNumber"
                                  render={({ handler, touched, hasError, pristine }) => (
                                    <div className="inputContainer">
                                      <input
                                        placeholder=""
                                        id="routingNumber"
                                        className={
                                          (touched || submitted) &&
                                          (hasError('required') || hasError('invalid'))
                                            ? 'form-control error'
                                            : 'form-control' + (handler().value ? ' notNull' : '')
                                        }
                                        {...handler()}
                                      />
                                      <label
                                        htmlFor="routingNumber"
                                        className={`label small ${
                                          !pristine || handler().value ? 'notEmpty' : ''
                                        }`}
                                      >
                                        Routing Number
                                        {hasError('required') && (
                                          <span className="error"> - Required</span>
                                        )}
                                        {hasError('invalid') && (
                                          <span className="error"> - Invalid</span>
                                        )}
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                              <div className="col-md-6 col-sm-12">
                                <FieldControl
                                  name="accountNumber"
                                  render={({ handler, touched, hasError, pristine }) => (
                                    <div className="inputContainer">
                                      <input
                                        placeholder=""
                                        id="accountNumber"
                                        className={
                                          (touched || submitted) &&
                                          (hasError('required') || hasError('invalid'))
                                            ? 'form-control error'
                                            : 'form-control' + (handler().value ? ' notNull' : '')
                                        }
                                        {...handler()}
                                      />
                                      <label
                                        htmlFor="accountNumber"
                                        className={`label small ${
                                          !pristine || handler().value ? 'notEmpty' : ''
                                        }`}
                                      >
                                        Account Number
                                        {hasError('required') && (
                                          <span className="error"> - Required</span>
                                        )}
                                        {hasError('invalid') && (
                                          <span className="error"> - Invalid</span>
                                        )}
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12 col-sm-12">
                                <FieldControl
                                  name="accountType"
                                  render={({ handler, touched, hasError, pristine }) => (
                                    <div className="inputContainer">
                                      <select
                                        id="accountType"
                                        className={
                                          (touched || submitted) && hasError('required')
                                            ? 'form-control error'
                                            : 'form-control'
                                        }
                                        {...handler()}
                                      >
                                        <option value="checking">Checking</option>
                                        <option value="savings">Savings</option>
                                      </select>
                                      <label
                                        htmlFor="accountNumber"
                                        className={`label small ${
                                          !pristine || handler().value ? 'notEmpty' : ''
                                        }`}
                                      >
                                        Account Type
                                        {hasError('required') && (
                                          <span className="error"> - Required</span>
                                        )}
                                        {hasError('invalid') && (
                                          <span className="error"> - Invalid</span>
                                        )}
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="top-padding bottom-padding">
                              <button
                                onClick={e => this.handleSubmit(e)}
                                className={`${isSubmitting ? 'btn-text-hide' : 'small'}`}
                                type="submit"
                                disabled={isSubmitting}
                                data-tip="React-tooltip"
                                ref={this.bankAccountButtonRef}
                              >
                                Pay with Bank Account
                                <span
                                  className={`${isSubmitting ? 'loader loader-pay-by-cc' : ''}`}
                                />
                              </button>
                            </div>
                          </div>
                        )}
                        {method === 'Check' && (
                          <div className="payment-form">
                            <b>Payment by Mail</b>
                            <br />
                            <p>
                              Make certified and personal checks or money orders made payable to
                              GIVE. Include your name and payment description on your check or money
                              order memo line. Note that it takes 5 business days for GIVE to
                              receive your check or money order.
                            </p>
                            <b>Mail your payment payable to GIVE to:</b>
                            <p>GIVE Volunteers </p>
                            <p>1900 West Nickerson St, STE 116 #123 </p>
                            <p>Seattle, Washington 98119 </p>
                            <p>USA</p>
                            <button
                              type="button"
                              className={`small ${isSubmitting ? 'btn-text-hide' : ''}`}
                              style={{
                                marginLeft: '-5px',
                              }}
                              onClick={e => this.handleSubmit(e)}
                              disabled={isSubmitting}
                              ref={this.checkButtonRef}
                            >
                              Let us know you'll be sending a check
                              <span className={`${isSubmitting ? 'loader loader-by-check' : ''}`} />
                            </button>
                          </div>
                        )}
                        <div>
                          {amountAppliedToAddOnDeposit > 0 && (
                            <p>
                              $
                              {amountAppliedToAddOnDeposit >
                              this.makePaymentForm.controls.paymentAmount.value
                                ? this.makePaymentForm.controls.paymentAmount.value
                                : amountAppliedToAddOnDeposit}{' '}
                              of this payment will be applied to your trip add-on deposit. Press the
                              button to proceed or remove an add-on to apply payments to your
                              primary trip. Note: Your add-on spot will only be reserved if you pay
                              the add-on deposit.
                            </p>
                          )}
                          {tripAmount - tripBalance < deposit && (
                            <p className="small center">
                              Note: Your spot on your trip and add-ons are not reserved until the
                              deposit(s) are paid in full.
                            </p>
                          )}
                        </div>
                      </form>
                    )}
                  />
                  {!!method && (
                    <p className="small center">
                      Please make sure you've read and agree to{' '}
                      <a href="#terms-and-conditions" onClick={this.openTermsAndConditionsModal}>
                        GIVE Terms and Conditions
                      </a>
                    </p>
                  )}
                </div>
              )}
              <div
                id="up-pay-monthly-container"
                style={{ display: type === 'Flexpay' ? 'block' : 'none' }}
              ></div>
              {!!method && type === 'Flexpay' && (
                <p className="small center">
                  Please make sure you've read and agree to{' '}
                  <a href="#terms-and-conditions" onClick={this.openTermsAndConditionsModal}>
                    GIVE Terms and Conditions
                  </a>
                </p>
              )}
              {type === 'Flexpay' && this.state.flexpayConfirmStatus !== 'hidden' && (
                <div>
                  <button
                    onClick={e => this.flexpayConfirm(e)}
                    className={`flexpay-button-confirm ${isSubmitting ? 'btn-text-hide' : ''}`}
                    type="submit"
                    id="flexpay-confirm"
                    data-tip="React-tooltip"
                    ref={this.creditCardButtonRef}
                    disabled={isSubmitting || this.state.flexpayConfirmStatus === 'disabled'}
                  >
                    Book Now
                    <span className={`${isSubmitting ? 'loader loader-pay-by-cc' : ''}`} />
                  </button>
                </div>
              )}
              {this.state.formMessage && (
                <div className="form-message-container">
                  <p className={`form-message ${this.state.formMessageClass}`}>
                    {this.state.formMessage}
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        <Modal
          isOpen={this.state.activeModal === 'termsAndConditions'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ApplicationTermsAndConditionsModal closeModal={this.closeModal} />
        </Modal>
      </Fragment>
    );
  }
}

MakePayment.propTypes = {
  setMakeDepositState: PropTypes.func,
  setTripState: PropTypes.func,
  tripId: PropTypes.string.isRequired,
  tripName: PropTypes.string.isRequired,
  trip: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  handleRouting: PropTypes.func.isRequired,
  additionalTripCost: PropTypes.number,
  payments: PropTypes.shape({
    deposit: PropTypes.number,
    addOnsDeposit: PropTypes.number,
    tripBalance: PropTypes.number,
    tripAmount: PropTypes.number,
  }).isRequired,
  tripIndex: PropTypes.number.isRequired,
};

MakePayment.defaultProps = {
  setTripState: () => {},
  setMakeDepositState: () => {},
};
